import { Header } from '@yanolja-org/core-ui';
import { IcMyFillH18, IcMyH18 } from '@yanolja-org/nol-icons-kit';

import type { HeaderActionProps, VisibleOn } from '@yanolja-org/core-ui';

/**
 * preset 전용 visibleOn — core-ui 의 `VisibleOn` 에 `'all'` sentinel 추가.
 * `'all'` 명시 시 Header.Action 의 visibleOn 을 `undefined` 로 변환 → 양쪽 모두 노출.
 *
 * preset 의 default 가 `'desktop'` 강제 (ES spec 의 destructure default fallback) 이라
 * 호스트가 *양쪽 모두 원함* 시그널을 `'all'` 로 표현.
 */
type PresetVisibleOn = VisibleOn | 'all';

export interface MyActionProps extends Omit<HeaderActionProps, 'icon' | 'activeIcon' | 'action' | 'visibleOn'> {
  action?: string;
  /** 표시 디바이스. `'all'` = 양쪽 모두. @default 'desktop' */
  visibleOn?: PresetVisibleOn;
}

export function MyAction({
  action = 'my',
  label = '마이',
  variant = 'label',
  visibleOn = 'desktop',
  href = '/mypage',
  ...rest
}: MyActionProps) {
  return (
    <Header.Action
      {...rest}
      action={action}
      activeIcon={<IcMyFillH18 />}
      href={href}
      icon={<IcMyH18 />}
      label={label}
      variant={variant}
      visibleOn={visibleOn === 'all' ? undefined : visibleOn}
    />
  );
}
